<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{'--width': widthVar}"  class="pageHeader">学生实训课列表</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <!-- <el-form-item label="用户类型">
          <el-select v-model="formInline.type" clearable placeholder="请选择用户类型 " @change="handleQuery">
            <el-option v-for="(item,index) in $store.state.posts" :key="index" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input v-model="formInline.name" @blur="handleQuery" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="工号/学号">
          <el-input v-model="formInline.number" @blur="handleQuery" placeholder="请输入工号/学号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
          <el-button type="primary" @click="handleAdd()">新增用户</el-button>
        </el-form-item> -->
        <!-- <el-form-item>
          <el-button type="primary" @click="handleAdd()">新增</el-button>
        </el-form-item> -->
        <!-- <el-form-item>
          <el-button type="primary" @click="handleExport">{{exportTitle}}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handlePrint">打印</el-button>
        </el-form-item> -->
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" ref="table" border style="width: 100%">
        <custom-table-column fixed prop="training_name" width="160" :label="`${$store.state.themeTitle}室名称`">
        </custom-table-column>
        <custom-table-column fixed prop="class_name" width="160" label="班级名称">
        </custom-table-column>
        <custom-table-column prop="course_name" width="160" label="课程名称">
        </custom-table-column>
        <custom-table-column prop="class_content" min-width="200" label="课程内容">
        </custom-table-column>
        <custom-table-column prop="course_name" width="160" label="课程名称">
        </custom-table-column>
        <custom-table-column prop="term" width="100" label="学期">
        </custom-table-column>
        <custom-table-column prop="teacher" width="100" label="指导老师">
        </custom-table-column>
        <custom-table-column prop="creator_name" width="100" label="创建人">
        </custom-table-column>
        <custom-table-column prop="created_at" width="160" label="创建时间">
        </custom-table-column>
        <custom-table-column prop="lesson_time" width="160" label="上课时间">
        </custom-table-column>
        <custom-table-column prop="lesson_end_time" width="160" label="上课结束时间">
        </custom-table-column>
        <custom-table-column prop="comment" min-width="200" label="备注">
        </custom-table-column>
        <!-- <custom-table-column prop="posts" label="职位">
        </custom-table-column> -->
        <!-- <custom-table-column prop="type" label="用户类型" width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.usertype==1">管理员</span>
            <span v-if="scope.row.usertype==2">授课老师</span>
            <span v-if="scope.row.usertype==3">实训老师</span>
            <span v-if="scope.row.usertype==4">学生</span>
          </template>
        </custom-table-column> -->
        <!-- <custom-table-column label="组织结构" min-width="220">
          <template slot-scope="scope">
            <span v-html="formatter(scope.row)"></span>
          </template>
        </custom-table-column> -->
        <!-- <custom-table-column fixed="right" label="操作" width="184">
          <template slot-scope="scope">
            <el-button @click="handleOrgan(scope.row)" type="text" size="small">分配组织结构</el-button>
            <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
            <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button>
          </template>
        </custom-table-column> -->
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false"  :title="title" :visible.sync="centerDialogVisible" width="706px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入姓名" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="用户名" prop="username">
          <el-input v-model="ruleForm.username" :disabled="type=='edit'" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="用户类型" prop="usertype">
          <el-select v-model="ruleForm.usertype" style="width:216px;" placeholder="请选择用户类型">
            <el-option v-for="(item,index) in $store.state.posts" :key="index" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="ruleForm.password" placeholder="请输入密码" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="工号/学号" prop="number">
          <el-input v-model="ruleForm.number" placeholder="请输入工号/学号" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type=='add'" @click="submitFormByFun('ruleForm',creatUser)">确认</el-button>
          <el-button type="primary" v-if="type=='edit'" @click="submitFormByFun('ruleForm',updateUser)">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false"  title="提示" :visible.sync="dialogVisible" width="400px">
      <span>{{delText}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMethod">确 定</el-button>
      </span>
    </el-dialog>
    <!-- <el-dialog :close-on-click-modal="false"  title="组织结构" :visible.sync="organDialogVisible" width="560px">
      <div style="padding:20px;background:#fff;min-width:500px;min-height:200px;">
        <el-tree :data="treeData" node-key="id" ref="tree" :check-strictly="true" :expand-on-click-node="true" show-checkbox :default-checked-keys="checkKeys" :props="defaultProps" default-expand-all>
        </el-tree>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="bindOrgan">确 定</el-button>
      </span>
    </el-dialog> -->
    <!-- <OrganDialog ref="organDia"></OrganDialog> -->
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinOrgan } from '@/assets/js/mixin/organization';
import Vue from 'vue';

export default {
  name: 'trainingRoom',
  mixins: [mixinList, mixinOrgan],
  data() {
    
    return {
      classRooms: [],
      
      checkKeys: [],
      defaultProps: {
        children: 'sub',
        label: 'name',
      },
      formInline: {
        name: '',
        type: '',
        number: '',
      },
      ruleForm: {
        name: '',
        username: '',
        password: '',
        usertype: '',
        number: '',
      },
      treeData: '',
      rules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        // password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        usertype: [{ required: true, message: '请选择用户类型', trigger: 'change' }],
      },
      organDialogVisible: false,
      type: 'add',
      tableName: '实训日志',
      uid: '',
    };
  },
  created() {},
  mounted() {
    // this.getList();
    // this.getTree();
  },
  methods: {
    onSubmit() {
      console.log('submit!');
    },
    formatter(row) {
      let slist = row.structureList;
      if (slist && slist.length) {
        slist = slist.map((item) => {
          return item.structure_text;
        });
      }
      return slist.join('<br/>');
      // console.log(row, column)
    },
    handleInstituteChange(e) {
      console.log(e);
      this.ruleForm.institute_name = this.$until.getLabelName(this.institutes, 'isid', 'ismc', e);
    },
    handleClassChange(e) {
      // this.ruleForm.room_id = e.id
      this.ruleForm.training_name = this.$until.getLabelName(this.$store.state.trainRooms, 'id', 'training_name', e);
    },
    handleOrgan(row) {
      this.organDialogVisible = true;
      this.uid = row.id;
      let slist = row.structureList;
      if (slist && slist.length) {
        slist = slist.map((item) => {
          return item.id;
        });
      }
      this.setCheckedKeys(slist);
    },
    setCheckedKeys(keys) {
      this.$nextTick(() => {
        this.$refs.tree.setCheckedKeys(keys);
      });
    },
    async bindOrgan() {
      let organKeys = this.$refs.tree.getCheckedKeys();
      if (!organKeys) {
        this.$message.warning('请先选择组织结构！');
      }
      let params = {
        uid: this.uid,
        structure_id: organKeys,
      };
      // console.log(params);
      // return;
      let res = await this.$api.update.bindOrgan(params);
      if (res.code == 0 && res.data) {
        this.organDialogVisible = false;
        this.$message.success('绑定成功！');
        this.resetChecked();
        this.getList();
      }
    },
    resetChecked() {
      this.$refs.tree.setCheckedKeys([]);
    },
    async getTree() {
      let res = await this.$api.instance.getOrgans();
      if (res.code == 0 && res.data) {
        this.treeData = res.data;
      }
    },
    handleSet() {
      this.centerDialogVisible = true;
    },
    handleClick() {
      this.centerDialogVisible = true;
    },
    handleBack() {
      this.$message.info('撤销中。。。');
    },
    handlePrint() {
      this.$message.info('打印中。。。');
    },
    async deleteMethod() {
      let params = { id: this.delid };
      let res = await this.$api.delet.deleteUser(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.getList();
      }
    },
    async creatUser() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      // if (params.lesson_time) {
      //   let timee = params.lesson_time.getTime() / 1000;
      //   params.lesson_time = this.$until.getTimeStr(timee, '-');
      // }
      let res = await this.$api.creat.creatUser(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async updateUser() {
      let params = this.$until.easyDeepCopy(this.ruleForm);;
      // console.log(params)
      // return
      let res = await this.$api.update.updateUser(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleQuery() {
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    async getList() {
      let params = {
        page: this.$refs.pageChild.page,
        size: this.$refs.pageChild.size,
      };
      // if (this.formInline.type || this.formInline.type == 0) {
      //   params.type = this.formInline.type;
      // }
      // if (this.formInline.name) {
      //   params.name = this.formInline.name;
      // }
      // if (this.formInline.number) {
      //   params.number = this.formInline.number;
      // }
      let res = await this.$api.query.getStudentTras(params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
